import { Facebook, Instagram, Mail, Globe } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="bg-brand-primary text-white shadow-md py-4 mt-auto">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <div className="space-y-3 text-center md:text-left w-full md:w-auto">
            <h3 className="font-serif text-lg font-medium text-white">Connect With Us</h3>
            <div className="space-y-2">
              <a href="mailto:help@pontis.life" className="hover:text-brand-accent transition-all flex items-center gap-2 group justify-center md:justify-start">
                <Mail className="h-4 w-4 group-hover:text-brand-accent transition-colors" />
                <span className="text-sm">support@pontis.life</span>
              </a>
              <a href="https://pontis.life" target="_blank" rel="noopener noreferrer" className="hover:text-brand-accent transition-all flex items-center gap-2 group justify-center md:justify-start">
                <Globe className="h-4 w-4 group-hover:text-brand-accent transition-colors" />
                <span className="text-sm">pontis.life</span>
              </a>
            </div>
          </div>

          {/* Legal Links */}
          <div className="flex flex-col items-center space-y-2 w-full md:w-auto">
            <h3 className="font-serif text-lg font-medium text-white">Legal</h3>
            <div className="flex gap-4 text-sm">
              <Link to="/privacy-policy" className="hover:text-brand-accent transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms-of-service" className="hover:text-brand-accent transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
          
          <div className="flex flex-col items-center space-y-3 w-full md:w-auto">
            <div className="flex gap-4">
              <a href="https://www.instagram.com/pontis_life/" target="_blank" rel="noopener noreferrer" className="p-2 rounded-full hover:bg-white/10 transition-colors" aria-label="Follow us on Instagram">
                <Instagram className="h-4 w-4" />
              </a>
              <a href="https://facebook.com/pontislife" target="_blank" rel="noopener noreferrer" className="p-2 rounded-full hover:bg-white/10 transition-colors" aria-label="Follow us on Facebook">
                <Facebook className="h-4 w-4" />
              </a>
            </div>
            <div className="w-full md:w-auto border-t border-white/20 pt-2 mt-1 text-center md:border-0 md:pt-0 md:mt-0">
              <p className="text-xs opacity-80">© {new Date().getFullYear()} Pontis. All rights reserved.</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};